export const MIN_MACRO_VAL = 0.5;
export const MAX_MACRO_VAL = 2.0;
export const MAX_MACRO_VAL_WATER = 5;
export const MIN_MACRO_VAL_WATER = 1;
export const CYCLE_LENGTH = 28;
